module.exports = __webpack_public_path__ + "static/media/hero.be6c16c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/hero.jpg
// module id = 333
// module chunks = 0